import { render, staticRenderFns } from "./ProfileDetails.vue?vue&type=template&id=e6d52846&scoped=true"
import script from "./ProfileDetails.vue?vue&type=script&lang=js"
export * from "./ProfileDetails.vue?vue&type=script&lang=js"
import style0 from "./ProfileDetails.vue?vue&type=style&index=0&id=e6d52846&prod&scoped=true&lang=css"
import style1 from "./ProfileDetails.vue?vue&type=style&index=1&id=e6d52846&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d52846",
  null
  
)

export default component.exports